import { render, staticRenderFns } from "./ScientificData.vue?vue&type=template&id=6a3f3452&scoped=true&"
import script from "./ScientificData.vue?vue&type=script&lang=js&"
export * from "./ScientificData.vue?vue&type=script&lang=js&"
import style0 from "./ScientificData.vue?vue&type=style&index=0&id=6a3f3452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f3452",
  null
  
)

export default component.exports